'use strict';

/* contact.js -- Components for contact */
var $ = require('jquery');
require('./forms/contact/controller');

function _registerEventHandlers() {

    $(document).ready(function () {

        console.log("contact.js initialized");

    });
}

_registerEventHandlers();